// src/components/atoms/InputField/index.js

import TextField from '@mui/material/TextField';

function InputField(props) {
    return <TextField {...props} />;
}

export default InputField;
